import { GET_USERS_REQUEST, GET_USERS_SUCCESS, GET_USERS_FAILURE, LOGIN_SUCCESS } from '../constants/user'

const defaultTokenState = {
  user: {},
  users: {},
  pending: false,
  requestType: ''
}

export default (state = defaultTokenState, action) => {

  var newState = {...state}

  switch (action.type){
    case GET_USERS_SUCCESS:
      newState.requestType = action.type
      newState.users = action.body;
      newState.pending = false;
      return newState;
    case GET_USERS_REQUEST:
      newState.requestType = action.type
      newState.pending = true;
      return newState;
    case GET_USERS_FAILURE:
      return newState;
    case LOGIN_SUCCESS:
      newState.user = action.body;
      return newState;
    default:  return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js